export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">投稿咨询</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            欢迎韩漫爱好者投稿推荐、版权合作与商务对接，布丁漫画团队将尽快回复
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
              <i className="ri-mail-send-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">作品投稿</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              原创韩漫作者可将作品发送至投稿邮箱，编辑团队将在3个工作日内评估回复
            </p>
            <span className="mt-3 text-sm font-medium text-primary-600">puddingcomic@投稿.com</span>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-briefcase-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">版权合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              版权方与海外合作平台可联系商务团队，探讨正版韩漫引入与联合运营方案
            </p>
            <span className="mt-3 text-sm font-medium text-accent-600">bd@puddingcomic.com</span>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
              <i className="ri-question-answer-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">读者反馈</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              阅读体验反馈、功能建议或内容推荐，欢迎通过以下方式与我们沟通
            </p>
            <span className="mt-3 text-sm font-medium text-secondary-600">feedback@puddingcomic.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}